import type { InitSessionConfigStep, VideoConfigStep } from '@types';
import type { Video } from '@model/Video';
import type { Audio } from '@model/Audio';

export interface TransformedQuestionStep {
  question: string;
  answers: string[];
  condition: string;
}

export interface TransformedVideoStep {
  video?: Video;
  audio?: Audio;
  condition: string;
  videoId?: string;
  audioId?: string;
}

export type TransformedConfigStep =
  | TransformedQuestionStep
  | TransformedVideoStep;

export type TransformedSessionConfig = Record<number, TransformedConfigStep>;

/**
 * Trasforma un array di InitSessionConfigStep in un oggetto con indici numerici
 * I video/audio vengono mantenuti come ID (string) e dovranno essere popolati
 * usando useMedia hook
 */
export const transformSessionConfig = (
  config: InitSessionConfigStep[]
): TransformedSessionConfig => {
  if (!Array.isArray(config) || config.length === 0) {
    return {};
  }

  const transformed: TransformedSessionConfig = {};

  config.forEach((step, index) => {
    // Se ha la proprietà 'question', è un QuestionConfigStep
    if ('question' in step && step.question !== undefined) {
      transformed[index] = {
        question: step.question,
        answers: step.answers || [],
        condition: step.condition || '',
      } as TransformedQuestionStep;
    } else {
      // Altrimenti è un VideoConfigStep
      const videoStep = step as VideoConfigStep;
      transformed[index] = {
        videoId: videoStep.video || undefined,
        audioId: videoStep.audio || undefined,
        condition: videoStep.condition || '',
        // video e audio verranno popolati usando useMedia
      } as TransformedVideoStep;
    }
  });

  return transformed;
};
